export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-background-50 to-background-200 border border-background-300/30 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
                APP下载
              </h2>
              <p className="mt-4 text-sm text-foreground-400 leading-relaxed max-w-md">
                下载蚂蚁影视官方APP，享受更流畅的追剧体验。支持iOS和Android双平台，1080P/4K高清画质，智能缓存离线观看，让精彩不间断。
              </p>

              <div className="mt-6 flex flex-wrap gap-3">
                <div className="flex items-center gap-3 px-5 py-3 bg-background-100 border border-background-300/30 rounded-xl">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/15">
                    <i className="ri-apple-fill text-primary-400 text-base"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">iOS 版本</div>
                    <div className="text-sm font-semibold text-foreground-100">v3.8.2</div>
                  </div>
                </div>
                <div className="flex items-center gap-3 px-5 py-3 bg-background-100 border border-background-300/30 rounded-xl">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500/15">
                    <i className="ri-android-fill text-primary-400 text-base"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-500">Android 版本</div>
                    <div className="text-sm font-semibold text-foreground-100">v3.8.2</div>
                  </div>
                </div>
              </div>

              <div className="mt-6 flex items-center gap-3">
                <span className="text-xs text-foreground-500">已通过安全检测</span>
                <i className="ri-shield-check-line text-accent-400 text-sm"></i>
                <span className="text-xs text-foreground-500">· 无病毒 · 无广告插件</span>
              </div>
            </div>

            <div className="w-full lg:w-[280px] p-8 md:p-12 flex items-center justify-center">
              <div className="relative">
                <div className="absolute inset-0 bg-primary-500/10 rounded-2xl blur-xl"></div>
                <div className="relative w-40 h-40 bg-background-100 border-2 border-primary-500/30 rounded-2xl flex items-center justify-center">
                  <div className="text-center">
                    <i className="ri-qr-code-line text-5xl text-foreground-300"></i>
                    <p className="mt-2 text-[10px] text-foreground-500">扫码下载APP</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}